export const IS_LOADING_VACATION_REQUESTS = "IS_LOADING_VACATION_REQUESTS";
export const GET_VACATION_REQUESTS = "GET_VACATION_REQUESTS";
export const FAIL_VACATION_REQUESTS = "FAIL_VACATION_REQUESTS";

export const IS_SAVE_VACATION_REQUEST = "IS_SAVE_VACATION_REQUEST";
export const FAIL_SAVE_VACATION_REQUEST = "FAIL_SAVE_VACATION_REQUEST";

export const CLEAR_ERROR = "CLEAR_ERROR";

export const UPDATE_VACATION_REQUEST_SUCCESS = "UPDATE_VACATION_REQUEST_SUCCESS";